import { SkillsType } from 'interfaces';

export const SKILLS: SkillsType[] = [
  { SKILL: 'HTML/CSS', LEVEL: 90 },
  { SKILL: 'JavaScript', LEVEL: 90 },
  { SKILL: 'React/Redux', LEVEL: 85 },
  { SKILL: 'NodeJs', LEVEL: 50 },
  { SKILL: 'Angular', LEVEL: 40 },
];
